'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Settings = {};

exports.__exports = Settings;
